import { render, staticRenderFns } from "./editPrivacySetting.vue?vue&type=template&id=65755cc8&scoped=true&"
import script from "./editPrivacySetting.vue?vue&type=script&lang=js&"
export * from "./editPrivacySetting.vue?vue&type=script&lang=js&"
import style0 from "./editPrivacySetting.vue?vue&type=style&index=0&id=65755cc8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65755cc8",
  null
  
)

export default component.exports